import { render, staticRenderFns } from "./jinFu.vue?vue&type=template&id=209f306e&scoped=true&"
import script from "./jinFu.vue?vue&type=script&lang=js&"
export * from "./jinFu.vue?vue&type=script&lang=js&"
import style0 from "./jinFu.vue?vue&type=style&index=0&id=209f306e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209f306e",
  null
  
)

export default component.exports